import {
  ModelConceptHierarchy,
  ModelConceptHierarchyLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import {
  isModelConceptHierarchy,
  isModelConceptHierarchyLabel,
} from 'src/containers/ProjectDiagram/utils/data';

export const getPreviousHierarchyConnection = (
  diagram: DiagramSnapshot,
  data: ModelConceptHierarchy | ModelConceptHierarchyLabel
) => {
  if (isModelConceptHierarchy(data)) {
    const found = diagram.model.modelData.draftData?.prevLinkDataMap[data.key];
    return found && isModelConceptHierarchy(found) ? found : null;
  }

  if (isModelConceptHierarchyLabel(data)) {
    const found = diagram.model.modelData.draftData?.prevNodeDataMap[data.key];
    return found && isModelConceptHierarchyLabel(found) ? found : null;
  }

  return null;
};
